import { UseQueryOptions, useMutation, useQuery } from '@tanstack/react-query';
import * as actions from './actions';

const icomxEmbedConfigQueryKey = ['icomx-embed-config'] as const;
const getIcomxResourceLinkQueryKey = (resource?: Partial<actions.IcomxResourceDescriptor>) => [
  'icomx-resource-link',
  resource?.resourceType,
  resource?.resourceId,
] as const;

export function useIcomxEmbedConfig(
  options?: Omit<
    UseQueryOptions<actions.IcomxEmbedConfig, unknown, actions.IcomxEmbedConfig, typeof icomxEmbedConfigQueryKey>,
    'queryFn' | 'queryKey'
  >
) {
  return useQuery(icomxEmbedConfigQueryKey, actions.getIcomxEmbedConfig, options);
}

export function useIcomxResourceLink(
  resource?: actions.IcomxResourceDescriptor,
  options?: Omit<
    UseQueryOptions<
      actions.IcomxResourceLink,
      unknown,
      actions.IcomxResourceLink,
      ReturnType<typeof getIcomxResourceLinkQueryKey>
    >,
    'queryFn' | 'queryKey'
  >
) {
  return useQuery(getIcomxResourceLinkQueryKey(resource), () => actions.getIcomxResourceLink(resource!), {
    enabled: !!resource?.resourceType && !!resource?.resourceId,
    ...options,
  });
}

export function useEnsureIcomxResourceLink() {
  return useMutation((resource: actions.IcomxResourceDescriptor) => actions.ensureIcomxResourceLink(resource));
}

export function useSyncIcomxResourceLink() {
  return useMutation((resource: actions.IcomxResourceDescriptor) => actions.syncIcomxResourceLink(resource));
}